
export default function PapilomaCenterSection() {
  return (
    <section id="papiloma-center" className="py-20 bg-gradient-to-br from-purple-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-purple-100 rounded-full px-6 py-2 mb-6">
            <i className="ri-shield-check-line text-purple-600 mr-2"></i>
            <span className="text-purple-800 font-semibold">Centro Especializado</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Papiloma Center
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Centro especializado en el diagnóstico, tratamiento y seguimiento integral 
            del Virus del Papiloma Humano (VPH) con tecnología láser de vanguardia.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <img 
              src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/9891a1927bb36a147634659dec4aac11.png"
              alt="Papiloma Center - Tratamiento Láser VPH"
              className="w-full h-80 object-cover object-center rounded-2xl shadow-2xl"
            />
          </div>
          
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Tratamiento Integral del VPH
            </h3>
            <p className="text-gray-600 mb-8 leading-relaxed">
              Nuestro Papiloma Center ofrece un enfoque integral para el tratamiento del VPH, 
              combinando tecnología láser CO2 de última generación con protocolos de seguimiento 
              especializados para garantizar los mejores resultados.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-microscope-line text-xl text-purple-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Diagnóstico Preciso</h4>
                  <p className="text-gray-600">Colposcopía digital y tipificación viral para diagnóstico exacto.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-flashlight-line text-xl text-purple-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Láser CO2 de Precisión</h4>
                  <p className="text-gray-600">Eliminación de lesiones sin cicatrices y con mínimo dolor.</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-heart-pulse-line text-xl text-purple-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">Seguimiento Especializado</h4>
                  <p className="text-gray-600">Protocolo de seguimiento personalizado para prevenir recidivas.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-2xl p-8 shadow-xl border border-gray-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Información Educativa sobre VPH
          </h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-information-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-3">¿Qué es el VPH?</h4>
              <p className="text-gray-600 text-sm">
                El Virus del Papiloma Humano es una infección común que puede causar 
                verrugas genitales y cambios celulares que pueden llevar al cáncer.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-3">Prevención</h4>
              <p className="text-gray-600 text-sm">
                La vacunación, el uso de preservativos y las revisiones regulares 
                son fundamentales para la prevención del VPH.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-medicine-bottle-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-3">Tratamiento</h4>
              <p className="text-gray-600 text-sm">
                El tratamiento temprano con láser CO2 es altamente efectivo 
                para eliminar lesiones y prevenir complicaciones.
              </p>
            </div>
          </div>
          
          <div className="mt-8 text-center">
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors whitespace-nowrap cursor-pointer"
              style={{ backgroundColor: '#20C6B2' }}
            >
              Consulta Especializada VPH
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
